import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Order } from '@app/core/business/order/order';
import { OrderStatus } from '@app/core/business/order/order-status';
import { AuthenticationService } from '@app/core/business/user/authentication.service';
import { environment } from '@env/environment';
import { User } from '@app/core/business/user/user';
import { ContextService } from '@app/core/service/context.service';
import { Router } from '@angular/router';
import { WizardManagerService } from '@app/core/service/wizards/wizard-manager.service';
import { WizardIdEnum } from '@app/core/model/enum/wizard-id.enum';

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent implements OnInit {
  @Input()
  availableLanguages: string[];
  @Input()
  activeLanguage: string;
  @Input()
  order: Order;
  @Output()
  languageEmitter: EventEmitter<string>;
  @Output()
  callbackEmitter: EventEmitter<string>;
  @Output()
  clickOutside: EventEmitter<any>;
  @Output()
  startScanEmit: EventEmitter<any>;
  public orderStatus = OrderStatus;
  public displayScan: Boolean = false;
  public showWizardMenu: boolean = false;

  constructor(
    public authenticationService: AuthenticationService,
    public contextService: ContextService,
    private router: Router,
    private wizardManager: WizardManagerService
  ) {
    this.languageEmitter = new EventEmitter<string>();
    this.clickOutside = new EventEmitter<any>();
    this.startScanEmit = new EventEmitter<any>();
    this.callbackEmitter = new EventEmitter<any>();
  }


  public ngOnInit(): void {
    let isApplication =
      navigator.userAgent.includes(environment.appUserAgent) || true;

    if (isApplication) {
      this.contextService.fullContext$.subscribe(fullContext => {
        if (
          // Offer/product can be showed without order
          fullContext.company &&
          fullContext.company.settings.showOfferWithoutOrder
        ) {
          this.displayScan = this.contextService.getCurrentStep() >= 2;
        } else if (fullContext.customer) {
          // Offer/product can't be showed without order
          this.displayScan = this.contextService.isFullContextComplete();
        } else {
          // Context is not complete
          this.displayScan = false;
        }
      });
    }
  }

  /**
   * Toggle l'affichage du menu wizard
   */
  public displayGuideMenu(): void {
    this.showWizardMenu = !this.showWizardMenu;
  }
  /**
   * Fermer le menu wizard
   */
  closeWizardMenu(): void {
    this.showWizardMenu = false;
  }


  public onLanguageFlagClicked(language: string): void {
    this.languageEmitter.emit(language);
  }

  public onCallbackRequest(): void {
    this.callbackEmitter.emit();
  }

  public onClickOutside(): void {
    this.closeWizardMenu();
    this.clickOutside.emit();
  }
  public startScan(): void {
    this.startScanEmit.emit();
  }

  public onLogout(): void {
    this.authenticationService.logout();
  }
}
